import { defaultHeaders, handleErrorResponse } from '@/services/engine/request.engine';
import { IQuoteSearchEntity, IQuoteSearchFilterEntity, QuoteApi, QuoteStatus } from '@phrospr/api-backend';
import { configuration, getAccessToken } from '@phrospr/lib-web-core';

export namespace QuoteServiceApi {
    export async function getRawQuotes(
        lead_id?: number,
        client_id?: number,
        quote_id?: number,
        quotes_from_logged_in_user?: boolean,
        lead_name?: string,
        quote_states?: QuoteStatus[],
        planning_item_id?: number,
        quoteSearchCore?: IQuoteSearchEntity,
        includeQuoteLines?: boolean,
    ) {
        const quoteFilter: IQuoteSearchFilterEntity = {
            lead_id,
            client_id,
            quote_id: quote_id ? `${quote_id}` : undefined,
            quotes_from_logged_in_user,
            lead_name,
            quote_states,
            planning_item_id,
        };

        const quoteSearch: IQuoteSearchEntity = {
            filter: quoteFilter,
            show: {
                sold_by_user: true,
                planning_item_lead: true,
                client: true,
                quote_lines: includeQuoteLines === true,
            },
            limit: quoteSearchCore?.limit,
            offset: quoteSearchCore?.offset,
        };

        const { data } = await QuoteApi.getQuoteListPost({
            quote_filter: quoteSearch,
        });

        return data;
    }

    export async function getPlanningItemFromQuote(quote_id: number) {
        const response = await fetch(`${configuration.apiUrl}/api/quote/get-planning-item-from-quote`, {
            method: 'POST',
            headers: {
                ...defaultHeaders(),
                Authorization: `Bearer ${await getAccessToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ quote_id: quote_id }),
        });
        if (response.status !== 200) {
            handleErrorResponse(response);
        }
        return await response.json();
    }
}
